import React from 'react'
import "./contact.css"
import { MdEmail } from "react-icons/md";
import { FaFacebookMessenger, FaLinkedin } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { useRef } from 'react';
import emailjs from '@emailjs/browser';


const Contact = () => {
  const form = useRef();

    const sendEmail = (e) => {
    e.preventDefault();

    emailjs
    .sendForm('service_qw1dm68', 'template_ryagemc', form.current, {
      publicKey: 'HjBISIpHLfr9ssaz0',
    })
    .then(
      () => {
        console.log('SUCCESS!');
      },
      (error) => {
        console.log('FAILED...', error.text);
      },
      
    );
    e.target.reset();
};
  return (
    <section id='contact'>
      <h5>Get in Touch</h5>
      <h2>Contact Me</h2>
      <div className="container contact_container">
        <div className="contact_options">
          <article className='contact_option'>
            <MdEmail className='contact_option-icon'/>
            <h4>Email</h4>
            <h5>hospicehounfodji@gmail.com</h5>
            <a href='mailto:hospicehounfodji@gmail.com' target="_blank" rel="noreferrer">Send a message</a>
          </article>
            <article className='contact_option'>
            <FaFacebookMessenger className='contact_option-icon'/>
            <h4>Messenger</h4>
            <h5>Hospice Hounfodji</h5>
            <a href="https://www.facebook.com/hospice.hounfodji.3" target="_blank" rel="noreferrer">Send a message</a>
          </article>
          <article className='contact_option'>
            <FaWhatsapp className='contact_option-icon'/>
            <h4>Whatsapp</h4>
            <h5>0022966783308</h5>
            <a href='https://api.whatsapp.com/send?phone=+22966723308' target="_blank" rel="noreferrer">Send a message</a>
          </article>
          
        </div>
        <form ref={form} onSubmit={sendEmail} >
          <input type="text" name='name' placeholder='Full Name' required />
          <input type="email" name='email' placeholder='Your Email' required />
          <textarea name='message' rows="7" placeholder="Type your message" required></textarea>
          <button type='submit' className='btn btn-primary'>Send Message</button>
        </form>
      </div>
    </section>
  )
}

export default Contact
